import React from 'react';
import PropTypes from 'prop-types';

import Form from '@pcid/components/forms/form';
import SubmitButton from '@pcid/components/forms/submit-button';
import InputGroup from '@pcid/components/forms/input-group';
import speck, {
	toExist,
	toBeAnEmail,
	errorCodes,
} from '@pcid/utils/validation';

export const formId = 'forgot-password';

const ForgotPasswordForm = ({ setSubmitDisabled, isSubmitDisabled }) => (
	<Form
		id={formId}
		className="forgot-password-form"
		heading="form.forgotPassword.heading"
		description="form.forgotPassword.description"
		showIcon={false}
	>
		<InputGroup
			name="email"
			type="email"
			className="forgot-password-form__email"
			label="common.email"
			autoComplete="username"
			validate={(email) => speck(
				email,
				toExist.else(errorCodes.emailRequired),
				toBeAnEmail
			)}
			onFocus={() => setSubmitDisabled(false)}
			required
		/>
		<SubmitButton
			messageId="form.forgotPassword.submit"
			disabled={isSubmitDisabled}
			analyticsId="forgot-password-screen"
		/>
	</Form>
);

ForgotPasswordForm.propTypes = {
	setSubmitDisabled: PropTypes.func,
	isSubmitDisabled: PropTypes.bool,
};

export default ForgotPasswordForm;
